import { c as _c } from "react/compiler-runtime";
import { useCallback, useContext, useEffect } from 'react';
import { skipToken } from '@apollo/client';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import isNewConsumerApp from 'commons/isNewConsumerApp';
import useModularPdp from 'global-state/modularPdp/useModularPdp';
import useSetModularPdp from 'global-state/modularPdp/useSetModularPdp';
import { GET_MODULAR_SOFA_BUNDLE } from './queries';
import { getBundleProductsWithOrientation } from './utils';
import useProductCardOptions from '../useProductCardOptions';
import ModularSofaBundleContext from './ModularSofaBundleContext';
const useModularPDPState = (id, slug, t0) => {
  const $ = _c(47);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const queryOptions = t1;
  const {
    skip: t2,
    skipQuery: t3
  } = queryOptions;
  const skip = t2 === undefined ? false : t2;
  const skipQuery = t3 === undefined ? true : t3;
  const modularState = useModularPdp();
  const setModularPdp = useSetModularPdp();
  const userLocation = useUserLocation();
  const skipModularBundleQuery = skip || skipQuery;
  const bundleContextData = useContext(ModularSofaBundleContext);
  const shouldUseContextData = bundleContextData != null && !skipModularBundleQuery;
  let t4;
  if ($[2] !== shouldUseContextData || $[3] !== skipModularBundleQuery || $[4] !== slug || $[5] !== userLocation?.stateShortName || $[6] !== userLocation?.zip) {
    t4 = isNewConsumerApp && (skipModularBundleQuery || shouldUseContextData) ? skipToken : {
      variables: {
        slug,
        zipCode: userLocation?.zip,
        ...getVisitorLocationQueryVariables(userLocation?.stateShortName)
      },
      skip: skipModularBundleQuery
    };
    $[2] = shouldUseContextData;
    $[3] = skipModularBundleQuery;
    $[4] = slug;
    $[5] = userLocation?.stateShortName;
    $[6] = userLocation?.zip;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    loading: modularBundleLoading,
    data: apolloBundleData,
    error: modularBundleError
  } = useSuspenseQuery(GET_MODULAR_SOFA_BUNDLE, t4);
  const modularBundleData = shouldUseContextData ? bundleContextData : apolloBundleData;
  let t5;
  if ($[8] !== skip) {
    t5 = {
      skip
    };
    $[8] = skip;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    data: optionsData
  } = useProductCardOptions(modularBundleData?.modularBundle?.modular_parent?.id, undefined, undefined, t5);
  let t6;
  if ($[10] !== setModularPdp) {
    t6 = isOpen => {
      setModularPdp(prevModularPdp => ({
        ...prevModularPdp,
        isModularAddProductSidebarOpen: isOpen
      }));
    };
    $[10] = setModularPdp;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const toggleAddProductsSidebar = t6;
  let t7;
  if ($[12] !== setModularPdp) {
    t7 = updatedOrder => {
      if (!updatedOrder) {
        return;
      }
      setModularPdp(prevModularPdp_0 => ({
        ...prevModularPdp_0,
        modularBundleOrderStatus: updatedOrder
      }));
    };
    $[12] = setModularPdp;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const updateModularOrderStatus = t7;
  let t8;
  if ($[14] !== setModularPdp) {
    t8 = updatedPrice => {
      setModularPdp(prevModularPdp_1 => ({
        ...prevModularPdp_1,
        modularTotalPrice: updatedPrice
      }));
    };
    $[14] = setModularPdp;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const updateModularOrderTotal = t8;
  let t9;
  if ($[16] !== setModularPdp) {
    t9 = updatedProduct => {
      setModularPdp(prevModularPdp_2 => {
        if (!updatedProduct || prevModularPdp_2?.currentModularGalleryProduct?.id === updatedProduct?.id) {
          return prevModularPdp_2;
        }
        return {
          ...prevModularPdp_2,
          currentModularGalleryProduct: updatedProduct
        };
      });
    };
    $[16] = setModularPdp;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const updateCurrentGalleryProduct = t9;
  let t10;
  if ($[18] !== setModularPdp || $[19] !== updateCurrentGalleryProduct) {
    t10 = sectionalProduct => {
      setModularPdp(prevModularPdp_3 => ({
        ...prevModularPdp_3,
        modularSectionalProduct: sectionalProduct
      }));
      updateCurrentGalleryProduct(sectionalProduct);
    };
    $[18] = setModularPdp;
    $[19] = updateCurrentGalleryProduct;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const setModularSectionalProduct = t10;
  let t11;
  if ($[21] !== modularBundleData || $[22] !== modularState?.modularSlug || $[23] !== optionsData.options || $[24] !== setModularPdp || $[25] !== skip) {
    t11 = () => {
      if (skip) {
        return;
      }
      if (modularBundleData?.modularBundle && optionsData?.options && modularState?.modularSlug !== modularBundleData?.modularBundle?.modular_parent?.slug) {
        const {
          modularBundle: t12
        } = modularBundleData;
        const {
          modular_parent,
          products,
          preConfiguredProducts
        } = t12;
        const collectionTitle = modular_parent?.name ? modular_parent.name.split(" ")[0] : "";
        const processedBundleProducts = getBundleProductsWithOrientation(products);
        setModularPdp(prevModularPdp_4 => ({
          ...prevModularPdp_4,
          modularParentSlug: modular_parent.slug,
          collectionTitle,
          preConfiguredProducts,
          bundleProducts: processedBundleProducts
        }));
      }
    };
    $[21] = modularBundleData;
    $[22] = modularState?.modularSlug;
    $[23] = optionsData.options;
    $[24] = setModularPdp;
    $[25] = skip;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const t12 = modularState?.modularSlug;
  let t13;
  if ($[27] !== modularBundleData || $[28] !== optionsData.options || $[29] !== setModularPdp || $[30] !== skip || $[31] !== t12) {
    t13 = [modularBundleData, t12, optionsData.options, setModularPdp, skip];
    $[27] = modularBundleData;
    $[28] = optionsData.options;
    $[29] = setModularPdp;
    $[30] = skip;
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  useEffect(t11, t13);
  if (skip) {
    let t14;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = {};
      $[33] = t14;
    } else {
      t14 = $[33];
    }
    return t14;
  }
  let t14;
  if ($[34] !== modularState) {
    t14 = {
      modularState
    };
    $[34] = modularState;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== setModularSectionalProduct || $[37] !== toggleAddProductsSidebar || $[38] !== updateCurrentGalleryProduct || $[39] !== updateModularOrderStatus || $[40] !== updateModularOrderTotal) {
    t15 = {
      toggleAddProductsSidebar,
      updateModularOrderStatus,
      updateModularOrderTotal,
      setModularSectionalProduct,
      updateCurrentGalleryProduct
    };
    $[36] = setModularSectionalProduct;
    $[37] = toggleAddProductsSidebar;
    $[38] = updateCurrentGalleryProduct;
    $[39] = updateModularOrderStatus;
    $[40] = updateModularOrderTotal;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== modularBundleError || $[43] !== modularBundleLoading || $[44] !== t14 || $[45] !== t15) {
    t16 = {
      loading: modularBundleLoading,
      error: modularBundleError,
      data: t14,
      actions: t15
    };
    $[42] = modularBundleError;
    $[43] = modularBundleLoading;
    $[44] = t14;
    $[45] = t15;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  return t16;
};
export default useModularPDPState;